import { deserialize } from 'cerialize'
import { RoleModel, ShortDataModel } from 'Models'
import { getDate } from 'Helpers'
import { QuestionModel, FileModel } from 'Pages/survey'

export class SurveyModel {
	@deserialize public id: number
	@deserialize public title: string
	@deserialize public description: string
	@deserialize public status: {
		status_slug: string
		status_translate: string
	}
	@deserialize public results_visible?: {
		results_visible_slug: string
		results_visible_translate: string
	}
	@deserialize public permissions?: {
		update: boolean
		destroy: boolean
		coverage: boolean
		results: boolean
	}
	@deserialize public current_user_attempt_status: string
	@deserialize public created_at: Date
	@deserialize public updated_at: Date
	@deserialize public inactive_at: Date
	@deserialize public active: boolean
	@deserialize public one_page: boolean
	@deserialize public author: {
		id: number
		name: string
		email: string
		phone: string
	}

	@deserialize public results_role_ids: string[]
	@deserialize public results_roles: RoleModel[]
	@deserialize public questions: QuestionModel[]
	@deserialize public attempts: string[]
	@deserialize public assigned_channels: ShortDataModel[]
	@deserialize public assigned_banks: ShortDataModel[]
	@deserialize public assigned_opfs: ShortDataModel[]
	@deserialize public assigned_regions: ShortDataModel[]
	@deserialize public assigned_roles: ShortDataModel[]
	@deserialize public partner_access_periods: number[]
	@deserialize public accessible_via_link: boolean
	@deserialize public attachments: FileModel[]

	public get created_at_formatted(): string | undefined {
		return getDate(this?.created_at)
	}

	public get inactive_at_formatted(): string | undefined {
		return getDate(this?.inactive_at)
	}
	public get status_translate(): string | undefined {
		return this?.status.status_translate
	}
}
